import NFTCard1Image from "../../../assets/images/NFTCard1Image.png";
import NFTCard2Image from "../../../assets/images/NFTCard2Image.png";
import NFTCard3Image from "../../../assets/images/NFTCard3Image.png";

export const collectionData = [
    {
        id: 1,
        title: "Bored ape yacht club",
        image: NFTCard1Image,
    },
    {
        id: 2,
        title: "Checks - VV Originals",
        image: NFTCard2Image,
    },
    {
        id: 3,
        title: "Azuki",
        image: NFTCard3Image,
    },
    {
        id: 4,
        title: "Bored ape yacht club",
        image: NFTCard1Image,
    },
    {
        id: 5,
        title: "Checks - VV Originals",
        image: NFTCard2Image,
    },
    {
        id: 6,
        title: "Azuki",
        image: NFTCard3Image,
    },
];
